/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */

export const PairingCode = {
  AUTO: 'auto',
  SEND: 'send',
};

export const PhotoLocation = {
  FILE: 'file',
  PATH: 'path',
};

export const StudyStatus = {
  COMPLETED: 'Completado',
  NOT_PROCESSED: 'No procesado',
  ERROR_SERVER: 'Error de programa',
  LOCKED: 'Bloqueado',
};

export const Steps = {
  UPLOADING_IMAGES: 'Subiendo imágenes a la nube',
  ANAlYZING_LATERALITY: 'Analizando lateralidad',
  EVALUATING_OPTICAL_DISC: 'Evaluando disco óptico',
  IDENTIFYING_INJURIES: 'Identificando lesiones en retina',
  EVALUATING_MODELS: 'Evaluando disco óptico y lesiones en retina',
};

export const Progress = {
  WAIT: 'En espera',
  UPLOADING_IMAGES: 'Subiendo imágenes...',
  PROCESSING: 'Procesando...',
  ANAlYZING_LATERALITY: Steps.ANAlYZING_LATERALITY,
  EVALUATING_OPTICAL_DISC: Steps.EVALUATING_OPTICAL_DISC,
  EVALUATING_MODELS: 'Evaluando disco óptico y retina',
  ANALYZING_QUALITY: 'Analizando calidad',
  IDENTIFYING_INJURIES: 'Identificando lesiones',
  FINALIZING: 'Finalizando...',
  COMPLETED: 'Completado',
  LOCKED: 'Bloqueado por otro operador',
  ERROR_NERWORK: 'Conexión interrumpida',
  ERROR_UPLOADING_IMAGES: 'Error de sincronización',
  ERROR_MODELS: 'Error de procesamiento',
  ERROR_SERVER: 'Error de programa',
};

export const ProcesSteps = {
  LOCK: 'lock',
  UPLOAD_IMAGES: 'upload_images',
  MODELS: 'models',
  FINALIZING: 'finalizing',
};

export const NoIAFlow = {
  BAD_QUALITY: 'bad_quality',
};

export const AcuityType = {
  BASAL: 'basal',
  FIXED: 'fixed',
};

export const Position = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  FLEXIBLE: 'flexible',
};

export const SN_VA_0 = 'SN-VA-0';

export const OperatorFindings = {
  OF_0: 'OF-0',
  OF_0_MISS: 'OF-0-MISS',
};

export const ErrorStatus = {
  BAD_REQUEST: 400,
  NOT_AUTHORIZED: 401,
  FORBIDDEN_ERROR: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  SERVER_ERROR: 500,
  NETWORK_ERROR: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  LEGAL_REASON_UNAVAILABLE: 451,
};

export const InteractionStatus = {
  PENDING: StudyStatus.NOT_PROCESSED,
  COMPLETED: StudyStatus.COMPLETED,
  LOCKED: StudyStatus.LOCKED,
};

export const SectionType = {
  TABLE: 'table',
  LIST: 'list',
  BULLET: 'bullet',
};

export const RenderColumns = {
  LANDSCAPE: {
    'retinia-adult': {
      4: {
        0: 5.7,
        1: 2.3,
        2: 2,
        3: 2,
      },
      3: {
        0: 5.7,
        1: 2.3,
        2: 4,
      },
      2: {
        0: 8,
        1: 4,
      },
      1: {
        0: 12,
      },
    },
    'retinia-rop': {
      3: {
        0: 6,
        1: 4,
        2: 2,
      },
      2: {
        0: 10,
        1: 2,
      },
      1: {
        0: 12,
      },
    },
    comment: {
      2: {
        0: 4,
        1: 8,
      },
      1: {
        0: 12,
      },
    },

  },
  PORTRAIT: {
    'retinia-adult': {
      3: {
        0: 7,
        1: 2,
        2: 3,
      },
      2: {
        0: 8,
        1: 4,
      },
      1: {
        0: 12,
      },
    },
    'retinia-rop': {
      3: {
        0: 7,
        1: 2,
        2: 3,
      },
      2: {
        0: 8,
        1: 4,
      },
      1: {
        0: 12,
      },
    },
    comment: {
      2: {
        0: 8,
        1: 4,
      },
      1: {
        0: 12,
      },
    },
  },
};

export const EXCLUDE_COUNTRIES_PHONE = [
  'asm',
  'ago',
  'ben',
  'io',
  'bq',
  'cg',
  'ci',
  'cu',
  'cw',
  'fk',
  'ir',
  'ki',
  'nr',
  'nf',
  'mp',
  'prk',
  'pw',
  'bl',
  'sh',
  'mf',
  'pm',
  'vc',
  'sx',
  'sd',
  'sy',
  'tk',
  'vir',
  'vat',
  'wf',
];

export const LIMIT_SEARCH_CHANNELS = 1;
export const LIMIT_SEARCH_POCS = 2;

export const INITIALIZE_PATIENT = {
  name: '',
  lastName: '',
  birthDate: null,
  patientId: '',
  enabledTerms: false,
  enabledPrivacy: false,
  operatorField: '',
  horusIP: '',
  phone: '',
  email: '',
  phoneCode: '+52',
  countryCode: 'MX',
  age: '',
  pairingId: '',
};

export const StepperStatus = {
  ACTIVE: 'active',
  CHECK: 'check',
  BLOCK: 'block',
};
